import uniq from 'lodash/uniq';

function setToLocalStorageErrorItem(
  errorTaskId,
  currentTicketId,
  categoryTickets
) {
  //normalize categoryTickets
  if (
    categoryTickets.substring(
      categoryTickets.length,
      categoryTickets.length - 2
    ) === "AB"
  )
    categoryTickets = "ticketsAB";
  else 
  {
    categoryTickets = "ticketsCD";}
  //end normalize categoryTickets

  let errorsArray = localStorage.getItem("errorsArray");
  if (errorsArray === null) {
    errorsArray = [
      {
        ticketId: parseInt(currentTicketId),
        ticketCategory: categoryTickets,
        ticketErrors: [errorTaskId],
      },
    ];
    localStorage.setItem("errorsArray", JSON.stringify(errorsArray));
  } else {
    errorsArray = JSON.parse(errorsArray);

    const errorsArrayItem = errorsArray.find(
      (errorItem) =>
        parseInt(currentTicketId) === errorItem.ticketId &&
        categoryTickets === errorItem.ticketCategory
    );

    if (errorsArrayItem !== undefined) {
      const index = errorsArray.indexOf(errorsArrayItem);
      errorsArray[index].ticketErrors = uniq([
        ...errorsArray[index].ticketErrors,
        errorTaskId,
      ]);

      localStorage.setItem("errorsArray", JSON.stringify(errorsArray));
    } else {
      errorsArray = [
        ...errorsArray,
        {
          ticketId: parseInt(currentTicketId),
          ticketCategory: categoryTickets,
          ticketErrors: [errorTaskId],
        },
      ];
      localStorage.setItem("errorsArray", JSON.stringify(errorsArray));
    }
  }
}

export default setToLocalStorageErrorItem;

